import { useTranslation } from 'react-i18next';

export function LanguageButton() {
    const { i18n } = useTranslation();
    const current = i18n.language?.toLowerCase().startsWith('sv') ? 'sv' : 'en';
    const next = current === 'en' ? 'sv' : 'en';

    const change = () => {
        i18n.changeLanguage(next);
        localStorage.setItem('lang', next);
    };

    return (
        <button
            onClick={change}
            className="absolute top-3 right-3 text-xs px-2 py-1 rounded bg-black/50 text-white hover:bg-black/70"
            title={`Switch to ${next.toUpperCase()}`}
            aria-label={`Switch language to ${next.toUpperCase()}`}
        >
            {current.toUpperCase()}
        </button>
    );
}